'use client'

import type { RadioProps } from '@heroui/react'
import { cn, useRadio, VisuallyHidden } from '@heroui/react'

export const PaymentMethodRadio = ({
  squared,
  bordered,
  ...rest
}: RadioProps & {
  squared?: boolean
  bordered?: boolean
}) => {
  const {
    Component,
    children,
    getBaseProps,
    getWrapperProps,
    getInputProps,
    getLabelProps,
    getLabelWrapperProps,
    getControlProps,
  } = useRadio(rest)

  const baseProps = getBaseProps() || {}
  const wrapperProps = getWrapperProps() || {}
  const inputProps = getInputProps() || {}
  const labelWrapperProps = getLabelWrapperProps() || {}
  const labelProps = getLabelProps() || {}
  const controlProps = getControlProps() || {}

  return (
    <Component
      {...baseProps}
      className={cn(
        'group hover:bg-grey-10 inline-flex items-center',
        'cursor-pointer gap-2 rounded p-1',
        'data-[selected=true]:border-navy',
        'data-[disabled=true]:bg-grey-10 data-[disabled=true]:cursor-not-allowed',
        squared ? 'w-3/5' : 'w-full',
        bordered ? 'border-grey-20 border-1' : 'border-transparent',
      )}
    >
      <VisuallyHidden>
        <input {...inputProps} />
      </VisuallyHidden>
      <span
        {...wrapperProps}
        className={cn(wrapperProps.className, squared && 'rounded')}
      >
        <span
          {...controlProps}
          className={cn(
            controlProps.className,
            squared &&
              'border-sky-blue h-full w-full rounded-none border-3 bg-white',
          )}
        />
      </span>
      <div
        {...labelWrapperProps}
        className={cn(labelWrapperProps.className, !squared && 'w-full')}
      >
        {children && (
          <span
            {...labelProps}
            className={cn(labelProps.className, 'flex items-center gap-2')}
          >
            {children}
          </span>
        )}
      </div>
    </Component>
  )
}
